import { useStoryblokState } from '@cinch-nx/data-storyblok'
import { Head } from '@cinch-nx/landing-ui-shared'
import { Wrapper } from '@cinch-nx/shared-ui'
import { useEffect, useState } from 'react'

import {
  ReviewCardsList,
  ReviewHubPagination,
  ReviewsHubFilters,
  ReviewsPageHeader,
} from '../lib/components'
import styles from './car-reviews-hub.module.css'

import type { CarReviewHubProps } from './get-static-props'

export function CarReviewsHubFeature({
  preview = false,
  isISR = false,
  story,
  makeOptions,
  modelOptions,
  generatedAt,
  currentPage,
  numberOfReviews,
  resultsPerPage,
  reviews,
  selectedMake,
  selectedModel,
}: CarReviewHubProps) {
  const { content } = useStoryblokState({ story, enableBridge: preview })
  const { title, subtitle } = content ?? {
    title: 'Loading',
    subtitle: 'Loading...',
  }
  const [SEO] = content?.SEO ?? [{}]
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setIsLoading(false)
  }, [reviews])

  return (
    <>
      <Head
        {...SEO}
        generatedAt={generatedAt}
        fallbackTitle="Cars Without The Faff - cinch"
        fallbackDescription="Welcome to cinch, the faff free way to buy & sell cars. We have thousands of used cars, ready to be sold to you."
      />
      <article className={styles.page}>
        <Wrapper isSlim>
          <ReviewsPageHeader title={title} subtitle={subtitle} />
          <ReviewsHubFilters
            selectedMake={selectedMake}
            selectedModel={selectedModel}
            makes={makeOptions}
            models={modelOptions}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            isISR={isISR}
          />
          <ReviewCardsList
            reviews={reviews}
            page={currentPage}
            isLoading={isLoading}
            selectedMake={selectedMake}
            selectedModel={selectedModel}
          />
          <ReviewHubPagination
            currentPage={currentPage}
            total={numberOfReviews}
            resultsPerPage={resultsPerPage}
            isISR={isISR}
          />
        </Wrapper>
      </article>
    </>
  )
}
